var _style, _path, _feBlend, _feBlend2, _feBlend3, _feBlend4, _feBlend5, _feBlend6, _feBlend7, _feBlend8, _feBlend9, _feBlend10, _feBlend11, _feBlend12, _feBlend13, _feBlend14, _feBlend15, _feBlend16, _feBlend17, _feBlend18, _feBlend19, _feBlend20, _feBlend21, _feBlend22, _feBlend23, _feBlend24, _feBlend25, _feBlend26, _feBlend27, _feBlend28, _feBlend29, _feBlend30, _feBlend31, _feBlend32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeWidget2 = function SvgHomeWidget2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1_kopie_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.9 243.3",
    style: {
      enableBackground: "new 0 0 115.9 243.3"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000011719862603373260310000002289113164663672209_);}\r\n\t.st2{fill:url(#SVGID_00000068663791433037075310000016193226389295891625_);}\r\n\t.st3{fill:url(#SVGID_00000098215165047559498270000006419395982573358261_);}\r\n\t.st4{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_00000045592342617798981920000005506694530385487751_);}\r\n\t\r\n\t\t.st6{mask:url(#SVGID_00000158020632222733417640000014580689365909767083_);fill:url(#SVGID_00000062895116420842777050000013489272280805021319_);}\r\n\t.st7{fill:url(#SVGID_00000027589533805465813450000005711430778936702866_);}\r\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000024684583942188872090000008208623560837377166_);}\r\n\t.st9{filter:url(#Adobe_OpacityMaskFilter_00000182497494898263596570000012963192601641011627_);}\r\n\t\r\n\t\t.st10{mask:url(#SVGID_00000163071426812550512610000010482528070669653682_);fill:url(#SVGID_00000182485880685947000470000014933038890250284183_);}\r\n\t.st11{fill:url(#SVGID_00000168826652887834579540000014695480281246129822_);}\r\n\t.st12{fill:url(#SVGID_00000065759550772597088520000018359182378598885765_);}\r\n\t.st13{filter:url(#Adobe_OpacityMaskFilter_00000151540104663806871460000015265685541973706932_);}\r\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_00000118391783909460379360000004420666817211232678_);}\r\n\t\r\n\t\t.st15{mask:url(#SVGID_00000180334919266222764960000017882642684309993121_);fill:url(#SVGID_00000100361473708158697660000001726488209381937068_);}\r\n\t.st16{fill:url(#SVGID_00000033350355624637267130000011481463024751856536_);}\r\n\t.st17{fill:url(#SVGID_00000173853593809186351860000015248636354611056771_);}\r\n\t.st18{fill:url(#SVGID_00000041277265676648281130000006865500246117001641_);}\r\n\t.st19{fill:url(#SVGID_00000101078141042642820640000012045946264929923750_);}\r\n\t.st20{filter:url(#Adobe_OpacityMaskFilter_00000018916974045288786090000012062092396728713893_);}\r\n\t.st21{filter:url(#Adobe_OpacityMaskFilter_00000010273235671088897780000012503917901124949423_);}\r\n\t\r\n\t\t.st22{mask:url(#SVGID_00000132087650066088498070000015880429373822502835_);fill:url(#SVGID_00000145754572851529456290000005047312876773129898_);}\r\n\t.st23{fill:url(#SVGID_00000031903237217764558670000000001574824590687398_);}\r\n\t.st24{filter:url(#Adobe_OpacityMaskFilter_00000145771477477729906950000000229395204796471683_);}\r\n\t.st25{filter:url(#Adobe_OpacityMaskFilter_00000077325190025440729650000013176635606446240657_);}\r\n\t\r\n\t\t.st26{mask:url(#SVGID_00000006707675882751779490000009276911398554079627_);fill:url(#SVGID_00000181775017813785015660000002006238160817767297_);}\r\n\t.st27{opacity:0.48;fill:url(#SVGID_00000072985743914901510170000010124713183996833462_);}\r\n\t.st28{fill:url(#SVGID_00000018951206762656636320000004120292092576697989_);}\r\n\t.st29{fill:url(#SVGID_00000129184581477769426530000012603303534518999716_);}\r\n\t.st30{filter:url(#Adobe_OpacityMaskFilter_00000152963903786304231390000017131852069560487564_);}\r\n\t.st31{filter:url(#Adobe_OpacityMaskFilter_00000099624609458199511000000010462495205850871709_);}\r\n\t\r\n\t\t.st32{mask:url(#SVGID_00000026148402646083459730000017597590687093592453_);fill:url(#SVGID_00000001656352421941077090000008352201424576464039_);}\r\n\t.st33{fill:url(#SVGID_00000068636448672693798940000014363708159612828075_);}\r\n\t.st34{fill:url(#SVGID_00000079478957923319681160000009735312403886322357_);}\r\n\t.st35{fill:url(#SVGID_00000057852267709176293160000018001796544559942787_);}\r\n\t.st36{filter:url(#Adobe_OpacityMaskFilter_00000098912563279866399470000016604256389011529661_);}\r\n\t.st37{filter:url(#Adobe_OpacityMaskFilter_00000152245734945632866570000011226388060838868917_);}\r\n\t\r\n\t\t.st38{mask:url(#SVGID_00000031905259928162068670000008663459249260552113_);fill:url(#SVGID_00000054226350727383131790000007710803573311712898_);}\r\n\t.st39{opacity:0.48;fill:url(#SVGID_00000168114093068291962030000012219338169585144754_);}\r\n\t.st40{filter:url(#Adobe_OpacityMaskFilter_00000120547086017572963500000004827791388279353004_);}\r\n\t.st41{filter:url(#Adobe_OpacityMaskFilter_00000137847121481802827390000010048353536695594900_);}\r\n\t\r\n\t\t.st42{mask:url(#SVGID_00000010302215665035546240000017752874341427081149_);fill:url(#SVGID_00000083769242284015906930000007166285538067111101_);}\r\n\t.st43{opacity:0.48;fill:url(#SVGID_00000130613583400742199360000010909469807241227929_);}\r\n\t.st44{fill:url(#SVGID_00000124857819289659112830000003152279696736538012_);}\r\n\t.st45{fill:url(#SVGID_00000174570404965977953920000010075704194900235967_);}\r\n\t.st46{fill:url(#SVGID_00000183223671087432022900000002239983508958581395_);}\r\n\t.st47{fill:url(#SVGID_00000036940274333559364970000003593546911468714935_);}\r\n\t.st48{filter:url(#Adobe_OpacityMaskFilter_00000106145204862785240150000002896356863876023686_);}\r\n\t.st49{filter:url(#Adobe_OpacityMaskFilter_00000154428248175688474360000000237598540249637041_);}\r\n\t\r\n\t\t.st50{mask:url(#SVGID_00000070828854031107910470000014304944000335584442_);fill:url(#SVGID_00000078736877326114532060000008563182304436450185_);}\r\n\t.st51{fill:url(#SVGID_00000116218389169388925480000012649941351842418874_);}\r\n\t.st52{filter:url(#Adobe_OpacityMaskFilter_00000083810524419632049320000010439752322232896173_);}\r\n\t.st53{filter:url(#Adobe_OpacityMaskFilter_00000052811682060078696580000004239633924326100127_);}\r\n\t\r\n\t\t.st54{mask:url(#SVGID_00000041278873046142835600000018290455649932762550_);fill:url(#SVGID_00000049203023743583611650000013096443289484940429_);}\r\n\t.st55{fill:url(#SVGID_00000069375372300704085580000005415784203313258667_);}\r\n\t.st56{fill:url(#SVGID_00000074404033331780308570000000507121424944379308_);}\r\n\t.st57{filter:url(#Adobe_OpacityMaskFilter_00000008860574842392959110000001184567548015769226_);}\r\n\t.st58{filter:url(#Adobe_OpacityMaskFilter_00000009578259245914680480000017298097373736061365_);}\r\n\t\r\n\t\t.st59{mask:url(#SVGID_00000176726143141189497370000010838702935965952696_);fill:url(#SVGID_00000128484485862310022600000015575573986250685856_);}\r\n\t.st60{fill:url(#SVGID_00000122721856573070886910000017231456979480023209_);}\r\n\t.st61{fill:url(#SVGID_00000117668391915876532060000005487437295681406865_);}\r\n\t.st62{fill:url(#SVGID_00000054976884367882006990000004209186866829653668_);}\r\n\t.st63{fill:url(#SVGID_00000118390661195234713920000014297685204177351353_);}\r\n\t.st64{filter:url(#Adobe_OpacityMaskFilter_00000176029851507462728750000013000135150036604326_);}\r\n\t.st65{filter:url(#Adobe_OpacityMaskFilter_00000118366751335396470480000007455297899752205487_);}\r\n\t\r\n\t\t.st66{mask:url(#SVGID_00000086654099471252062930000001043881197975009427_);fill:url(#SVGID_00000104684254344487392570000007808460226320825018_);}\r\n\t.st67{fill:url(#SVGID_00000135674961343819451190000005820923241881084830_);}\r\n\t.st68{filter:url(#Adobe_OpacityMaskFilter_00000015321331800602678300000002706258915120022714_);}\r\n\t.st69{filter:url(#Adobe_OpacityMaskFilter_00000127006285600325878030000002495088652181961116_);}\r\n\t\r\n\t\t.st70{mask:url(#SVGID_00000165918539357803768870000013818289115321494921_);fill:url(#SVGID_00000067944860498351368430000016911453728450706829_);}\r\n\t.st71{opacity:0.48;fill:url(#SVGID_00000000927388474614844370000005360888110385917070_);}\r\n\t.st72{fill:url(#SVGID_00000179634045314014780430000012895362637804689561_);}\r\n\t.st73{fill:url(#SVGID_00000065062088736480588460000014035464784264605869_);}\r\n\t.st74{filter:url(#Adobe_OpacityMaskFilter_00000129911855472218054760000016222615253347110569_);}\r\n\t.st75{filter:url(#Adobe_OpacityMaskFilter_00000147208510165511750070000003625403790033383867_);}\r\n\t\r\n\t\t.st76{mask:url(#SVGID_00000151519621649904983010000010526196978316751517_);fill:url(#SVGID_00000036963334668297055730000014667615110247563193_);}\r\n\t.st77{fill:url(#SVGID_00000073685159610694846540000006751956679335186577_);}\r\n\t.st78{fill:url(#SVGID_00000024715573725690262870000009090144652230111105_);}\r\n\t.st79{fill:url(#SVGID_00000011742880936244263370000014314114984158796427_);}\r\n\t.st80{filter:url(#Adobe_OpacityMaskFilter_00000088107753276381616390000005079189194165538959_);}\r\n\t.st81{filter:url(#Adobe_OpacityMaskFilter_00000004519596815176348440000018405301293708402606_);}\r\n\t\r\n\t\t.st82{mask:url(#SVGID_00000014631936728157890270000003233362396226530700_);fill:url(#SVGID_00000147194643177459945300000012206901267420181422_);}\r\n\t.st83{opacity:0.48;fill:url(#SVGID_00000067206809495093569790000008798147201641063811_);}\r\n\t.st84{filter:url(#Adobe_OpacityMaskFilter_00000031888166395088776080000005177932868805141164_);}\r\n\t.st85{filter:url(#Adobe_OpacityMaskFilter_00000153666314762402282950000016876246677486008704_);}\r\n\t\r\n\t\t.st86{mask:url(#SVGID_00000178894788354444188940000014741333640520391851_);fill:url(#SVGID_00000041978775459602438300000000349375632685056152_);}\r\n\t.st87{opacity:0.48;fill:url(#SVGID_00000121263373143522554380000011713004359002735488_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.4801,
    y1: 130.9889,
    x2: 29.4801,
    y2: 98.3077,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,97.9c0,0-2.4,13.2,6.2,33.1c0,0,7.6-12.6,6-33.1H22.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000125577456519846508940000002416540684712149922_",
    cx: 313.5531,
    cy: -905.6005,
    r: 0,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125577456519846508940000002416540684712149922_)"
    },
    d: "M37.9,25.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089537057105847659840000015459011631358736298_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.8354,
    y1: 69.9555,
    x2: 11.8354,
    y2: 100.1272,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000089537057105847659840000015459011631358736298_)"
    },
    points: "18.4,89.7 4.2,101.9  9.7,71.7 14.7,69.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177471006616120265950000017810688555946007983_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.2997,
    y1: 69.9555,
    x2: 47.2997,
    y2: 100.1272,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000177471006616120265950000017810688555946007983_)"
    },
    points: "39.7,89.7 53.8,101.9  48.3,71.7 43.3,69.2  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 41.1,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 41.1,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000174587938954905820720000008263201530826869398_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000005246310094017853290000003190664811215059119_",
    filterUnits: "userSpaceOnUse",
    x: 41.1,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 41.1,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000174587938954905820720000008263201530826869398_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000005246310094017853290000003190664811215059119_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057843335753337967850000007273584981859068051_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.9658,
    y1: -845.4188,
    x2: 294.0706,
    y2: -854.902,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000174587938954905820720000008263201530826869398_)",
      fill: "url(#SVGID_00000057843335753337967850000007273584981859068051_)"
    },
    points: " 45.3,70.2 46.5,70.8 48.9,97.7 41.1,91  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146470105584527419320000000678405201476814486_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.9658,
    y1: -845.4188,
    x2: 294.0706,
    y2: -854.902,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000146470105584527419320000000678405201476814486_)"
    },
    points: "45.3,70.2 46.5,70.8  48.9,97.7 41.1,91  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000044171425787607368390000001626906385082758321_",
    filterUnits: "userSpaceOnUse",
    x: 9.2,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 9.2,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000181796216723168604940000007502089775331256726_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000044171425787607368390000001626906385082758321_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000022548972481943537780000001697342738664857743_",
    filterUnits: "userSpaceOnUse",
    x: 9.2,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 9.2,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000181796216723168604940000007502089775331256726_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000022548972481943537780000001697342738664857743_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102506330861073205130000000384534182581326271_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.2968,
    y1: -842.295,
    x2: 284.3867,
    y2: -899.3831,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000181796216723168604940000007502089775331256726_)",
      fill: "url(#SVGID_00000102506330861073205130000000384534182581326271_)"
    },
    points: " 12.8,70.2 11.6,70.8 9.2,97.7 17,91  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101795295877820164870000008887004682696365961_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.2968,
    y1: -842.295,
    x2: 284.3867,
    y2: -899.3831,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101795295877820164870000008887004682696365961_)"
    },
    points: "12.8,70.2 11.6,70.8  9.2,97.7 17,91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096060336550929763620000012532700538554560689_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5347,
    y1: 96.5422,
    x2: 29.5347,
    y2: 92.303,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 91.4,
    style: {
      fill: "url(#SVGID_00000096060336550929763620000012532700538554560689_)"
    },
    width: 20.2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000013872875507835140890000006318895500127826826_",
    filterUnits: "userSpaceOnUse",
    x: 18.9,
    y: 91.4,
    width: 20.2,
    height: 5.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 18.9,
    y: 91.4,
    width: 20.2,
    height: 5.4,
    id: "SVGID_00000060715214297630410580000005471391062463037615_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000013872875507835140890000006318895500127826826_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000085222370645745016460000007641335945535362963_",
    filterUnits: "userSpaceOnUse",
    x: 18.9,
    y: 91.4,
    width: 20.2,
    height: 5.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 18.9,
    y: 91.4,
    width: 20.2,
    height: 5.4,
    id: "SVGID_00000060715214297630410580000005471391062463037615_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000085222370645745016460000007641335945535362963_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062159869742323585810000017292308143772383118_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.89,
    y1: -832.5776,
    x2: 302.8709,
    y2: -872.4995,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000060715214297630410580000005471391062463037615_)",
      fill: "url(#SVGID_00000062159869742323585810000017292308143772383118_)"
    },
    points: " 18.9,91.4 39.1,91.4 39.1,96.8 37.6,96.8 37.6,93.1 18.9,93.1  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180337352659710402130000004339019487962581426_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.89,
    y1: -832.5776,
    x2: 302.8709,
    y2: -872.4995,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000180337352659710402130000004339019487962581426_)"
    },
    points: "18.9,91.4 39.1,91.4  39.1,96.8 37.6,96.8 37.6,93.1 18.9,93.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110435733864273586880000008007899707816575907_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9178,
    y1: 97.3669,
    x2: 38.1515,
    y2: 97.3669,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 96.8,
    style: {
      fill: "url(#SVGID_00000110435733864273586880000008007899707816575907_)"
    },
    width: 17.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098928556445339008950000017269859692883109268_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5673,
    y1: 87.8544,
    x2: 29.5673,
    y2: 42.9324,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098928556445339008950000017269859692883109268_)"
    },
    d: "M44.7,34.8C40.2,16.4,29.3,3.3,29,3 c0,0,0,0,0,0v0c0,0-11.2,13.2-15.7,31.8c-1.1,4.7-1.8,9.8-1.8,15c0,4.7,0.2,9,0.5,12.9c1.3,18.3,5.1,28.6,5.1,28.6h12v0h12 c0,0,3.7-10.3,5.1-28.6c0.3-3.9,0.5-8.3,0.5-12.9C46.5,44.6,45.8,39.5,44.7,34.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039855199811362464050000011685519971952557245_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.2472,
    y1: -912.462,
    x2: 272.8063,
    y2: -907.3787,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039855199811362464050000011685519971952557245_)"
    },
    d: "M44.7,34.8c-5,1.5-10.2,2.3-15.7,2.3 c-5.5,0-10.7-0.8-15.7-2.3C17.8,16.2,29,3,29,3S40.2,16.2,44.7,34.8z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000118364331005374619370000011775602687867146428_",
    filterUnits: "userSpaceOnUse",
    x: 29,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000145022981534339646260000004490151305469850255_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000118364331005374619370000011775602687867146428_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000169554751004212415500000016332386570639567249_",
    filterUnits: "userSpaceOnUse",
    x: 29,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000145022981534339646260000004490151305469850255_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000169554751004212415500000016332386570639567249_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036959463162978297570000004695329776847004329_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.1321,
    y1: -894.4223,
    x2: 450.4134,
    y2: -765.2964,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000145022981534339646260000004490151305469850255_)",
      fill: "url(#SVGID_00000036959463162978297570000004695329776847004329_)"
    },
    d: " M46.5,49.9c0,4.7-0.2,9-0.5,12.9C44.7,81.1,41,91.4,41,91.4h-4.9C49.1,44.8,29.3,3.5,29,3c0.2,0.3,11.2,13.3,15.7,31.8 C45.8,39.5,46.5,44.6,46.5,49.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001662627580387744430000014020429202499221654_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.1321,
    y1: -894.4223,
    x2: 450.4134,
    y2: -765.2964,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001662627580387744430000014020429202499221654_)"
    },
    d: "M46.5,49.9c0,4.7-0.2,9-0.5,12.9 C44.7,81.1,41,91.4,41,91.4h-4.9C49.1,44.8,29.3,3.5,29,3c0.2,0.3,11.2,13.3,15.7,31.8C45.8,39.5,46.5,44.6,46.5,49.9z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000119105443309807495190000007251637391165737624_",
    filterUnits: "userSpaceOnUse",
    x: 11.6,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 11.6,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000179645883993620245740000012012463473218591924_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000119105443309807495190000007251637391165737624_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000085930820669169126520000008401701891723728831_",
    filterUnits: "userSpaceOnUse",
    x: 11.6,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 11.6,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000179645883993620245740000012012463473218591924_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000085930820669169126520000008401701891723728831_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016779008724316299790000009359841738772470948_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.6423,
    y1: -869.2474,
    x2: 261.4683,
    y2: -961.1441,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000179645883993620245740000012012463473218591924_)",
      fill: "url(#SVGID_00000016779008724316299790000009359841738772470948_)"
    },
    d: " M11.6,49.9c0,4.7,0.2,9,0.5,12.9c1.3,18.3,5.1,28.6,5.1,28.6h4.9C9,44.8,28.9,3.5,29.1,3c-0.2,0.3-11.2,13.3-15.7,31.8 C12.3,39.5,11.6,44.6,11.6,49.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110452183746467483100000002298214240329017766_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.6423,
    y1: -869.2474,
    x2: 261.4683,
    y2: -961.1441,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000110452183746467483100000002298214240329017766_)"
    },
    d: "M11.6,49.9 c0,4.7,0.2,9,0.5,12.9c1.3,18.3,5.1,28.6,5.1,28.6h4.9C9,44.8,28.9,3.5,29.1,3c-0.2,0.3-11.2,13.3-15.7,31.8 C12.3,39.5,11.6,44.6,11.6,49.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053514179296794409420000005432231036996419987_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9748,
    y1: 81.9404,
    x2: 28.9748,
    y2: 97.5897,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000053514179296794409420000005432231036996419987_)"
    },
    points: "29,68.2 29,106 27.8,94.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075158430550980462550000001440129347218413992_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.1617,
    y1: 98.2693,
    x2: 30.1617,
    y2: 86.2319,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075158430550980462550000001440129347218413992_)"
    },
    points: "29,68.2 29,106 30.2,94.9  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000106132658616107311210000017782801099811353763_",
    filterUnits: "userSpaceOnUse",
    x: 21.8,
    y: 42,
    width: 15.3,
    height: 15.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 21.8,
    y: 42,
    width: 15.3,
    height: 15.3,
    id: "SVGID_00000101082179334777430600000006351929072502120627_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000106132658616107311210000017782801099811353763_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000083772195791854615260000002239528535870789783_",
    filterUnits: "userSpaceOnUse",
    x: 21.8,
    y: 42,
    width: 15.3,
    height: 15.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 21.8,
    y: 42,
    width: 15.3,
    height: 15.3,
    id: "SVGID_00000101082179334777430600000006351929072502120627_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000083772195791854615260000002239528535870789783_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051381002254866339040000016760888386439188100_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.754,
    y1: -878.0123,
    x2: 269.6029,
    y2: -904.7644,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      mask: "url(#SVGID_00000101082179334777430600000006351929072502120627_)",
      fill: "url(#SVGID_00000051381002254866339040000016760888386439188100_)"
    },
    cx: 29.5,
    cy: 49.7,
    r: 7.6
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034798662485622245190000013777998821574543527_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.754,
    y1: -878.0123,
    x2: 269.6029,
    y2: -904.7644,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000034798662485622245190000013777998821574543527_)"
    },
    cx: 29.5,
    cy: 49.7,
    r: 7.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159430841081226943440000004299678663813035657_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5682,
    y1: 42.1126,
    x2: 29.5682,
    y2: 53.3248,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000159430841081226943440000004299678663813035657_)"
    },
    cx: 29,
    cy: 49.2,
    r: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009581120199602849860000006916175104515868600_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.0426,
    y1: 53.0971,
    x2: 28.4314,
    y2: 47.4448,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009581120199602849860000006916175104515868600_)"
    },
    d: "M34,49.2c0,2.7-2.2,5-5,5 c-0.5,0-1-0.1-1.5-0.2c-0.6-0.2-1.2-0.5-1.7-0.9c-0.4-0.3-0.7-0.7-1-1.1c-0.5-0.8-0.8-1.7-0.8-2.7c0-2.7,2.2-5,5-5 c1,0,1.9,0.3,2.7,0.8c0.4,0.3,0.8,0.6,1.1,1c0.4,0.5,0.7,1.1,0.9,1.7C33.9,48.2,34,48.7,34,49.2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000135665695642256050640000018033442012364922047_",
    filterUnits: "userSpaceOnUse",
    x: 24,
    y: 44.3,
    width: 7.7,
    height: 7.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend13 || (_feBlend13 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 44.3,
    width: 7.7,
    height: 7.7,
    id: "SVGID_00000114059318456655662220000016074093011297599122_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000135665695642256050640000018033442012364922047_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000111185081664074847970000006211183610515975572_",
    filterUnits: "userSpaceOnUse",
    x: 24,
    y: 44.3,
    width: 7.7,
    height: 7.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend14 || (_feBlend14 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 44.3,
    width: 7.7,
    height: 7.7,
    id: "SVGID_00000114059318456655662220000016074093011297599122_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000111185081664074847970000006211183610515975572_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145763850432657275430000010849630551318802067_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0987,
    y1: -889.3186,
    x2: 281.9336,
    y2: -865.3962,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000114059318456655662220000016074093011297599122_)",
      fill: "url(#SVGID_00000145763850432657275430000010849630551318802067_)"
    },
    d: " M31.7,45.1l-6.9,6.9c-0.5-0.8-0.8-1.7-0.8-2.7c0-2.7,2.2-5,5-5C30,44.3,31,44.5,31.7,45.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084532188130088684620000012497005918959689662_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0987,
    y1: -889.3186,
    x2: 281.9336,
    y2: -865.3962,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000084532188130088684620000012497005918959689662_)"
    },
    d: "M31.7,45.1l-6.9,6.9 c-0.5-0.8-0.8-1.7-0.8-2.7c0-2.7,2.2-5,5-5C30,44.3,31,44.5,31.7,45.1z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000058574657025386487990000002249129962330456487_",
    filterUnits: "userSpaceOnUse",
    x: 25.8,
    y: 46,
    width: 7.9,
    height: 7.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend15 || (_feBlend15 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 25.8,
    y: 46,
    width: 7.9,
    height: 7.9,
    id: "SVGID_00000102509544925051036520000017435682806675697312_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000058574657025386487990000002249129962330456487_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000057135746756872574500000000561496303072928178_",
    filterUnits: "userSpaceOnUse",
    x: 25.8,
    y: 46,
    width: 7.9,
    height: 7.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend16 || (_feBlend16 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 25.8,
    y: 46,
    width: 7.9,
    height: 7.9,
    id: "SVGID_00000102509544925051036520000017435682806675697312_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000057135746756872574500000000561496303072928178_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060032514941142882630000014914496051323143608_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.7074,
    y1: -887.1619,
    x2: 306.91,
    y2: -865.8091,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000102509544925051036520000017435682806675697312_)",
      fill: "url(#SVGID_00000060032514941142882630000014914496051323143608_)"
    },
    d: " M33.8,47.7L27.5,54c-0.6-0.2-1.2-0.5-1.7-0.9l7-7C33.2,46.5,33.6,47.1,33.8,47.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074413333865852864610000008677744162897218205_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.7074,
    y1: -887.1619,
    x2: 306.91,
    y2: -865.8091,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000074413333865852864610000008677744162897218205_)"
    },
    d: "M33.8,47.7L27.5,54 c-0.6-0.2-1.2-0.5-1.7-0.9l7-7C33.2,46.5,33.6,47.1,33.8,47.7z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036228733394857948070000000872287284857974913_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.3931,
    y1: 240.2038,
    x2: 67.3931,
    y2: 180.3987,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036228733394857948070000000872287284857974913_)"
    },
    d: "M55.8,179.6c0,0-4.4,24.2,11.3,60.7 c0,0,14-23.1,11-60.7H55.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000084490148084152425860000010747080623288321941_",
    cx: 358.9522,
    cy: -884.1786,
    r: 0,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084490148084152425860000010747080623288321941_)"
    },
    d: "M83.3,46.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152972319355034539720000000576640395258790286_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.1042,
    y1: 128.5154,
    x2: 35.1042,
    y2: 183.7283,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152972319355034539720000000576640395258790286_)"
    },
    points: "47.5,164.7 21.6,186.9  31.7,131.6 40.8,127.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091704526956464745970000000917827552061742767_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.0022,
    y1: 128.5154,
    x2: 100.0022,
    y2: 183.7283,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000091704526956464745970000000917827552061742767_)"
    },
    points: "86.5,164.7 112.4,186.9  102.3,131.6 93.2,127.1  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000058550524313533676820000002411304705833639325_",
    filterUnits: "userSpaceOnUse",
    x: 89.1,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend17 || (_feBlend17 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 89.1,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000029031678242964237710000008243127525849879705_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000058550524313533676820000002411304705833639325_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000112625939032474990000000008217834072008152482_",
    filterUnits: "userSpaceOnUse",
    x: 89.1,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend18 || (_feBlend18 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 89.1,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000029031678242964237710000008243127525849879705_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000112625939032474990000000008217834072008152482_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008150805987558765600000003170822568362634881_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.3268,
    y1: -774.0488,
    x2: 323.3,
    y2: -791.4028,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000029031678242964237710000008243127525849879705_)",
      fill: "url(#SVGID_00000008150805987558765600000003170822568362634881_)"
    },
    points: " 96.9,128.9 99,130 103.4,179.2 89.1,167  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129184583481854582180000005329555469951963058_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.3268,
    y1: -774.0488,
    x2: 323.3,
    y2: -791.4028,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000129184583481854582180000005329555469951963058_)"
    },
    points: "96.9,128.9 99,130  103.4,179.2 89.1,167  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000078733908460155753910000004844620536138843268_",
    filterUnits: "userSpaceOnUse",
    x: 30.7,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend19 || (_feBlend19 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 30.7,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000118380083508227315990000001266602239330600094_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000078733908460155753910000004844620536138843268_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000038397118053004523130000008920224473335670457_",
    filterUnits: "userSpaceOnUse",
    x: 30.7,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend20 || (_feBlend20 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 30.7,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000118380083508227315990000001266602239330600094_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000038397118053004523130000008920224473335670457_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183217121232485113790000010498858309827142807_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7342,
    y1: -768.3323,
    x2: 305.5789,
    y2: -872.801,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000118380083508227315990000001266602239330600094_)",
      fill: "url(#SVGID_00000183217121232485113790000010498858309827142807_)"
    },
    points: " 37.2,128.9 35.1,130 30.7,179.2 45,167  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166663015665758244900000008286384388651401888_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7342,
    y1: -768.3323,
    x2: 305.5789,
    y2: -872.801,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000166663015665758244900000008286384388651401888_)"
    },
    points: "37.2,128.9 35.1,130  30.7,179.2 45,167  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104700315139415920660000006458729890734995115_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.493,
    y1: 177.1679,
    x2: 67.493,
    y2: 169.4103,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.4,
    y: 167.7,
    style: {
      fill: "url(#SVGID_00000104700315139415920660000006458729890734995115_)"
    },
    width: 37,
    height: 10
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000166654141913178969090000007749439560857066175_",
    filterUnits: "userSpaceOnUse",
    x: 48.4,
    y: 167.7,
    width: 37,
    height: 10
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend21 || (_feBlend21 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 48.4,
    y: 167.7,
    width: 37,
    height: 10,
    id: "SVGID_00000031178131328746610270000017096436399938462899_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000166654141913178969090000007749439560857066175_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000050639191861672248580000001750671386112572063_",
    filterUnits: "userSpaceOnUse",
    x: 48.4,
    y: 167.7,
    width: 37,
    height: 10
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend22 || (_feBlend22 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 48.4,
    y: 167.7,
    width: 37,
    height: 10,
    id: "SVGID_00000031178131328746610270000017096436399938462899_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000050639191861672248580000001750671386112572063_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150808904744372462370000006339322956945096608_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.099,
    y1: -750.5501,
    x2: 339.4042,
    y2: -823.6052,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000031178131328746610270000017096436399938462899_)",
      fill: "url(#SVGID_00000150808904744372462370000006339322956945096608_)"
    },
    points: " 48.4,167.7 85.4,167.7 85.4,177.7 82.7,177.7 82.7,170.9 48.4,170.9  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091014205835771432640000005733594957032896402_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.099,
    y1: -750.5501,
    x2: 339.4042,
    y2: -823.6052,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000091014205835771432640000005733594957032896402_)"
    },
    points: "48.4,167.7 85.4,167.7  85.4,177.7 82.7,177.7 82.7,170.9 48.4,170.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123429794731779491260000003700712763446723759_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7246,
    y1: 178.677,
    x2: 83.2614,
    y2: 178.677,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.2,
    y: 177.7,
    style: {
      fill: "url(#SVGID_00000123429794731779491260000003700712763446723759_)"
    },
    width: 31.5,
    height: 1.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139271413582611060190000003817756600104291231_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5527,
    y1: 161.2697,
    x2: 67.5527,
    y2: 79.0645,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139271413582611060190000003817756600104291231_)"
    },
    d: "M95.7,64.2C87.5,30.4,67.4,6.5,67,6 c0,0,0,0,0,0v0c0,0-20.4,24.1-28.7,58.2C36.3,72.8,35,82.1,35,91.7c0,8.5,0.3,16.4,0.8,23.7c2.4,33.4,9.3,52.3,9.3,52.3H67v0 h21.9c0,0,6.9-18.9,9.3-52.3c0.5-7.2,0.8-15.1,0.8-23.7C99,82.1,97.7,72.8,95.7,64.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012437792018599416190000000732743891137693336_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.6919,
    y1: -896.7348,
    x2: 284.3875,
    y2: -887.4327,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012437792018599416190000000732743891137693336_)"
    },
    d: "M95.7,64.2C86.6,67,77,68.5,67,68.5 c-10,0-19.6-1.5-28.7-4.3C46.6,30.1,67,6,67,6S87.4,30.1,95.7,64.2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000080187266548180717030000005773951742412273816_",
    filterUnits: "userSpaceOnUse",
    x: 67,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend23 || (_feBlend23 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000182492493763746094440000010445501540216649090_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000080187266548180717030000005773951742412273816_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000093171777076689549090000010831063180939586232_",
    filterUnits: "userSpaceOnUse",
    x: 67,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend24 || (_feBlend24 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000182492493763746094440000010445501540216649090_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000093171777076689549090000010831063180939586232_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033334050032551863760000010763236536632486576_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.2426,
    y1: -863.723,
    x2: 609.4003,
    y2: -627.4285,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000182492493763746094440000010445501540216649090_)",
      fill: "url(#SVGID_00000033334050032551863760000010763236536632486576_)"
    },
    d: " M99,91.7c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3h-9C103.8,82.5,67.4,6.9,67,6c0.4,0.5,20.5,24.4,28.7,58.2 C97.7,72.8,99,82.1,99,91.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176039631967885592760000002722674891558989974_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.2426,
    y1: -863.723,
    x2: 609.4003,
    y2: -627.4285,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176039631967885592760000002722674891558989974_)"
    },
    d: "M99,91.7c0,8.5-0.3,16.4-0.8,23.7 c-2.4,33.4-9.3,52.3-9.3,52.3h-9C103.8,82.5,67.4,6.9,67,6c0.4,0.5,20.5,24.4,28.7,58.2C97.7,72.8,99,82.1,99,91.7z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000019671325908701341530000010010540808095864743_",
    filterUnits: "userSpaceOnUse",
    x: 35.2,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend25 || (_feBlend25 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 35.2,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000019664953859332885300000014425306716487153798_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000019671325908701341530000010010540808095864743_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000093867702458230851710000006421552767596836286_",
    filterUnits: "userSpaceOnUse",
    x: 35.2,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend26 || (_feBlend26 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 35.2,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000019664953859332885300000014425306716487153798_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000093867702458230851710000006421552767596836286_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046337900006576228220000013715427135824266652_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.4757,
    y1: -817.6542,
    x2: 263.6394,
    y2: -985.821,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000019664953859332885300000014425306716487153798_)",
      fill: "url(#SVGID_00000046337900006576228220000013715427135824266652_)"
    },
    d: " M35.2,91.7c0,8.5,0.3,16.4,0.8,23.7c2.4,33.4,9.3,52.3,9.3,52.3h9C30.4,82.5,66.8,6.9,67.2,6c-0.4,0.5-20.5,24.4-28.7,58.2 C36.5,72.8,35.2,82.1,35.2,91.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003823365957461265980000016002917807575904910_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.4757,
    y1: -817.6542,
    x2: 263.6394,
    y2: -985.821,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000003823365957461265980000016002917807575904910_)"
    },
    d: "M35.2,91.7 c0,8.5,0.3,16.4,0.8,23.7c2.4,33.4,9.3,52.3,9.3,52.3h9C30.4,82.5,66.8,6.9,67.2,6c-0.4,0.5-20.5,24.4-28.7,58.2 C36.5,72.8,35.2,82.1,35.2,91.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169540429561667215200000010762352082329133753_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.4685,
    y1: 150.4473,
    x2: 66.4685,
    y2: 179.0848,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000169540429561667215200000010762352082329133753_)"
    },
    points: "67,125.3 67,194.6  64.8,174.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089537117440663373530000004259574200238730125_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.6404,
    y1: 180.3284,
    x2: 68.6404,
    y2: 158.3005,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000089537117440663373530000004259574200238730125_)"
    },
    points: "67,125.3 67,194.6  69.2,174.2  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000171682959217117113560000002403981600335518386_",
    filterUnits: "userSpaceOnUse",
    x: 53.8,
    y: 77.4,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend27 || (_feBlend27 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 53.8,
    y: 77.4,
    width: 28,
    height: 28,
    id: "SVGID_00000045587935211197305610000002447131531954182824_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000171682959217117113560000002403981600335518386_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000054968209561179988720000013041100032138116237_",
    filterUnits: "userSpaceOnUse",
    x: 53.8,
    y: 77.4,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend28 || (_feBlend28 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 53.8,
    y: 77.4,
    width: 28,
    height: 28,
    id: "SVGID_00000045587935211197305610000002447131531954182824_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000054968209561179988720000013041100032138116237_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021111675275362134700000017445033247821669786_",
    gradientUnits: "userSpaceOnUse",
    x1: 352,
    y1: -833.6934,
    x2: 278.5253,
    y2: -882.6486,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000045587935211197305610000002447131531954182824_)",
      fill: "url(#SVGID_00000021111675275362134700000017445033247821669786_)"
    },
    d: " M81.8,91.4c0,7.7-6.3,14-14,14c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14C75.6,77.4,81.8,83.7,81.8,91.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020393077328027221160000012734232831488367023_",
    gradientUnits: "userSpaceOnUse",
    x1: 352,
    y1: -833.6934,
    x2: 278.5253,
    y2: -882.6486,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020393077328027221160000012734232831488367023_)"
    },
    d: "M81.8,91.4c0,7.7-6.3,14-14,14 c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14C75.6,77.4,81.8,83.7,81.8,91.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023985401682824037000000012687378583123759780_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5544,
    y1: 77.5643,
    x2: 67.5544,
    y2: 98.082,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000023985401682824037000000012687378583123759780_)"
    },
    cx: 67,
    cy: 90.6,
    r: 12.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158011884534978097890000011530131424847583363_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.0823,
    y1: 97.6653,
    x2: 65.474,
    y2: 87.3219,
    gradientTransform: "matrix(1 0 0 1 -0.5523 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158011884534978097890000011530131424847583363_)"
    },
    d: "M76.1,90.6c0,5-4.1,9.1-9.1,9.1 c-1,0-1.9-0.2-2.8-0.4c-1.1-0.4-2.2-0.9-3.1-1.7c-0.7-0.6-1.3-1.3-1.8-2c-0.9-1.4-1.5-3.1-1.5-5c0-5,4.1-9.1,9.1-9.1 c1.8,0,3.5,0.5,5,1.5c0.8,0.5,1.4,1.1,2,1.8c0.7,0.9,1.3,1.9,1.7,3.1C76,88.7,76.1,89.6,76.1,90.6z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000069380407424168360000000008123108583666699922_",
    filterUnits: "userSpaceOnUse",
    x: 57.9,
    y: 81.5,
    width: 14.1,
    height: 14.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend29 || (_feBlend29 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 57.9,
    y: 81.5,
    width: 14.1,
    height: 14.1,
    id: "SVGID_00000054946718131569381400000007203331376136876214_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000069380407424168360000000008123108583666699922_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000018228652506255923760000017425492728506213565_",
    filterUnits: "userSpaceOnUse",
    x: 57.9,
    y: 81.5,
    width: 14.1,
    height: 14.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend30 || (_feBlend30 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 57.9,
    y: 81.5,
    width: 14.1,
    height: 14.1,
    id: "SVGID_00000054946718131569381400000007203331376136876214_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000018228652506255923760000017425492728506213565_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156558472628844287670000006968981251635030663_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.8008,
    y1: -854.3836,
    x2: 301.0899,
    y2: -810.6067,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000054946718131569381400000007203331376136876214_)",
      fill: "url(#SVGID_00000156558472628844287670000006968981251635030663_)"
    },
    d: " M72,83L59.4,95.5c-0.9-1.4-1.5-3.1-1.5-5c0-5,4.1-9.1,9.1-9.1C68.8,81.5,70.5,82,72,83z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112613915692815620880000009587517824343286162_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.8008,
    y1: -854.3836,
    x2: 301.0899,
    y2: -810.6067,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000112613915692815620880000009587517824343286162_)"
    },
    d: "M72,83L59.4,95.5 c-0.9-1.4-1.5-3.1-1.5-5c0-5,4.1-9.1,9.1-9.1C68.8,81.5,70.5,82,72,83z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000107549540666220540240000000504037783130310543_",
    filterUnits: "userSpaceOnUse",
    x: 61.2,
    y: 84.8,
    width: 14.5,
    height: 14.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend31 || (_feBlend31 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 61.2,
    y: 84.8,
    width: 14.5,
    height: 14.5,
    id: "SVGID_00000160191009302322734520000001131766007215797122_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000107549540666220540240000000504037783130310543_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000030454842349981376850000007261263858991382161_",
    filterUnits: "userSpaceOnUse",
    x: 61.2,
    y: 84.8,
    width: 14.5,
    height: 14.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend32 || (_feBlend32 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 61.2,
    y: 84.8,
    width: 14.5,
    height: 14.5,
    id: "SVGID_00000160191009302322734520000001131766007215797122_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000030454842349981376850000007261263858991382161_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087372789677390167570000000877875010646102194_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.765,
    y1: -850.4369,
    x2: 346.7956,
    y2: -811.3622,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000160191009302322734520000001131766007215797122_)",
      fill: "url(#SVGID_00000087372789677390167570000000877875010646102194_)"
    },
    d: " M75.7,87.8L64.2,99.3c-1.1-0.4-2.2-0.9-3.1-1.7L74,84.8C74.7,85.7,75.3,86.7,75.7,87.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003824499419247370580000017409467107437497473_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.765,
    y1: -850.4369,
    x2: 346.7956,
    y2: -811.3622,
    gradientTransform: "matrix(1 0 0 1 -275.6054 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000003824499419247370580000017409467107437497473_)"
    },
    d: "M75.7,87.8L64.2,99.3 c-1.1-0.4-2.2-0.9-3.1-1.7L74,84.8C74.7,85.7,75.3,86.7,75.7,87.8z"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeWidget2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home-widget-2.a345ea08269f81846be961ccd7b828bf.svg";